import { IconComponent, IconsTypes } from "@/ui/icon";

import GradientBorderRadius from "@/ui/gradient-border-radius";
import Input from "@/ui/input";
import { useToken } from "@/pages/token-v2/hooks/use-token";
import { formatDecimalStringFloat } from "@/utils/currency";

const BalanceNativeTokenInputV2 = ({
  youPayNative,
  onYouPayNativeChange,
  balancePercent,
  onBalancePercentChange,
}: {
  youPayNative: string;
  onYouPayNativeChange: (v: string) => void;
  balancePercent: string;
  onBalancePercentChange: (v: string) => void;
}) => {
  const token = useToken();

  const chainIcon = (
    token?.pair?.networkId === 1 ? "ethereum" : "solana"
  ) as string;

  return (
    <GradientBorderRadius
      gradient="default-border"
      hover="r-100"
      className="focus-within:before:bg-gradient-100"
    >
      <div className="px-[0.625rem] h-[1.875rem] flex items-center justify-between">
        <Input
          value={youPayNative}
          activeWhenInputIsNotEmpty={false}
          gradient="none"
          hover="none"
          placeholder="0"
          gradientClassName="focus-within:before:bg-none"
          className="!h-[1.375rem]"
          onChange={(v) => {
            const formattedValue = formatDecimalStringFloat(v, true, false, 8);

            onYouPayNativeChange(formattedValue);
          }}
          leftSide={
            <div className="w-[1.125rem] h-full flex items-center justify-center">
              <Input.Accordion>
                <IconComponent
                  className="w-[1.125rem] h-[1.125rem]"
                  name={chainIcon as IconsTypes}
                />
              </Input.Accordion>
            </div>
          }
        />
        <div className="flex items-center gap-x-[0.3125rem]">
          <div className="w-[5.125rem] text-xs">
            <Input
              activeWhenInputIsNotEmpty={false}
              value={balancePercent}
              gradient="none"
              hover="none"
              placeholder="0"
              gradientClassName="focus-within:before:bg-none"
              className="!text-opacity-50 h-[1.375rem] text-end"
              onChange={(v) => {
                if (Number(v) > 100 || Number(v) < 0) {
                  return;
                }

                const formattedValue = formatDecimalStringFloat(v, true, false);

                onBalancePercentChange(formattedValue);
              }}
              rightSide={
                <div className="h-[1.375rem] flex items-center justify-center">
                  <Input.Accordion>%</Input.Accordion>
                </div>
              }
            />
          </div>

          <span
            onClick={() => onBalancePercentChange("100")}
            className="text-xs cursor-pointer"
          >
            MAX
          </span>
        </div>
      </div>
    </GradientBorderRadius>
  );
};

export default BalanceNativeTokenInputV2;
